import React, { Component } from 'react';
import moment from 'moment';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as ReportsActions/* , Selectors as ReportsSelectors */ } from 'store/ducks/reports';

import { Page, Breadcrumbs } from 'components';
import { Filters } from './components';

class Accountant extends Component {
  state = {
    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Relatórios', to: '/reports' },
      { name: 'Contábil', to: '' },
    ],
    filter: {
      date_start: null,
      date_end: null,
    },
  };


  componentDidUpdate(oldProps, oldState) {
    const { filter } = this.state;

    if (oldState.filter.date_start !== filter.date_start || oldState.filter.date_end !== filter.date_end) {
      const date_formatted = filter.date_start
        ? `${filter.date_start !== null ? moment(filter.date_start).format('DD/MM/YYYY') : ''} ${
            filter.date_end !== null ? '-' : ''
          } ${filter.date_end !== null ? moment(filter.date_end).format('DD/MM/YYYY') : ''}`
        : '';

      this.setState({ filter: { ...filter, date_formatted } });
    }
  }

  handleChangeFilter = async (name, value) => {
    const { filter } = this.state;

    this.setState({ filter: { ...filter, [name]: value } });
  };

  handleCleanFilter = async e => {
    e.preventDefault();

    this.setState({
      filter: {
        date_start: null,
        date_end: null,
      },
    });
  };

  handleExport = () => {
    const { filter } = this.state;
    const { exportReportAccountantRequest } = this.props;

    exportReportAccountantRequest(filter);
  };

  render() {
    const { breadcrumbs, filter } = this.state;

    return (
      <Page className="page-reports">
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <header className="page-reports-header">
          <Page.Title>Relatório Contábil</Page.Title>

          <div className="row">
            <div className="col-md-10">
              <Filters data={filter} onChange={this.handleChangeFilter} onClean={this.handleCleanFilter} />
            </div>

            <div className="col-md-2">
               <button className="button-submit" onClick={this.handleExport}>
                Exportar Planilha
              </button>
            </div>
          </div>
        </header>
      </Page>
    );
  }
}


const mapActions = dispatch => bindActionCreators(ReportsActions, dispatch);

export default connect(
  null,
  mapActions,
)(Accountant);
